/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Val_Quantity_PositiveInputs */

const vi_aml_val_quantity_positive = /** @type {(inputs: Aml_Val_Quantity_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng phải lớn hơn 0`)
};

/**

* @param {Aml_Val_Quantity_PositiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_val_quantity_positive = /** @type {((inputs?: Aml_Val_Quantity_PositiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Val_Quantity_PositiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_val_quantity_positive(inputs)
});